module.exports = "th{\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/club-injuries/club-injuries-list/club-all-injuries.component.css
// module id = ./src/app/pages/club-injuries/club-injuries-list/club-all-injuries.component.css
// module chunks = main